import { createPinia } from 'pinia';
import { createApp } from 'vue';
import InlineSvg from 'vue-inline-svg';

import App from '@/App.vue';
import I18n from '@/i18n';
import Router from '@/router';
import Filter from '@/utils/filter';

const app = createApp(App);

app.component('inline-svg', InlineSvg);
app.use(createPinia());
app.use(I18n);

// Page routes
app.use(Router);

// Global filters
app.config.globalProperties.$filters = {
  ...Filter,
};

app.mount('#HUBFacilitatorPortal');
